import { createContext, useContext } from "react"

export type CacheContextValue = {
  cacheTimestamp: string | undefined
  resetCacheTimestamp: () => void
  updateCacheTimestamp: (timestamp: string | undefined) => void
  updateMultipleCacheTimestamps: (timestamps: (string | undefined)[]) => void
}

export const CacheContext = createContext<CacheContextValue | undefined>(
  undefined,
)

export function useCacheContext() {
  const context = useContext(CacheContext)
  if (context === undefined) {
    throw new Error("useCacheContext must be used within a CacheProvider")
  }

  return context
}
